module.exports = __webpack_public_path__ + "static/media/Button_Circular.9cdf3430.svg";